import type { AccordionTabProps } from '../Accordion'

const faqData: Array<AccordionTabProps> = [
  {
    id: 'faq-prequalification',
    title: 'What’s prequalification?',
    content:
      'Prequalification is a way for you to see if you’ll be approved for a Mission Lane Visa® Credit Card without a hard credit check.',
    contentParagraphBreak:
      'Unlike a credit card application—which has a hard credit check that impacts your credit score—prequalification tells you what your application outcome will be before you submit your official application.',
  },
  {
    id: 'faq-hard-credit-check',
    title: 'What’s a hard credit check?',
    content:
      'A hard credit check occurs when a financial institution—such as a credit card issuer—checks your credit to make a lending decision. A hard credit check can reduce your credit score by a few points.',
  },
  {
    id: `faq-what-happens`,
    title: 'What happens if I’m pre-qualified?',
    content:
      'If you’re pre-qualified, we’ll show you the card offer you’re pre-qualified for. You’ll then have the option to submit a pre-filled credit card application. Once you submit, we’ll run a hard credit check before you get an answer.',
  },
  {
    id: 'faq-what-happens-not',
    title: 'What happens if I’m not pre-qualified?',
    content:
      'If you’re not pre-qualified, we’ll let you know why—with no impact to your credit score. You won’t be able to submit a credit card application.',
  },
  {
    id: 'faq-how-long',
    title: 'How long will this take? ',
    content:
      'On average, it takes less than 5 minutes to 1) fill out our prequalification form, 2) get an answer, and 3) submit your application if you’re pre-qualified. ',
  },
  {
    id: 'faq-how-long-valid',
    title: 'How long is my outcome valid for?',
    content:
      'Your prequalification outcome is valid for 30 days. After that, you will need to go through prequalification again.',
  },
  {
    id: 'faq-what-will-you-do',
    title: 'What will you do with my information?',
    content:
      'We’ll use your information to run a soft credit check with the credit bureaus—which doesn’t impact your credit score—and verify your identity. We may also use it to let you know about future Mission Lane offers.',
  },
  {
    id: 'faq-can-i-be-declined',
    title: 'Can I be declined after I’m pre-qualified?',
    content:
      'Yes, the only way to be declined after you’re pre-qualified is if we can’t verify your identity or income with the information you’ve provided. If you’re pre-qualified, you’ll be approved as long as we can verify the information you’ve filled out on your prequalification form.',
  },
  {
    id: 'faq-what-are-the-terms',
    title: 'What are the terms of my offer?',
    content:
      'If you’re pre-qualified, we’ll show you the terms of your offer—such as the Annual Percentage Rate (APR), Annual Fee, or Rewards Rate.',
  },
]

export default faqData
